import {init} from '/src/com/yext/platform/users/js/emailverificationrenderer';

document.addEventListener('DOMContentLoaded', function() {
  var initIdentifier = $('body').data('jsinit');
  switch (initIdentifier) {
    case 'emailverification':
      init();
      break;
  }
});
